import { FunctionComponent, useEffect, useState } from 'react';
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  useHistory,
  useRouteMatch,
} from 'react-router-dom';
import { Loader } from '../../components/LoaderComponent';
import { isNonEmptyString } from '../../helpers/StringUtils';
import { AuthLayout } from '../../layouts/Auth/AuthLayout';
import { Routes } from '../../routes/Routes';
import { authLayoutRoutes } from '../../routes/RoutesSelection';
import { NotFoundScreen } from '../../screens/Auth/NotFoundScreen';
import { useAuthDispatch, useAuthStore } from '../../store/AuthStore';

export const AuthStack: FunctionComponent = () => {
  const history = useHistory();
  const userIdMatch = useRouteMatch('/patient/:uid')?.isExact;
  const hcpReferralHash = useAuthStore((state) => state.hcpReferralHash);
  const hasHcpReferralHash = isNonEmptyString(hcpReferralHash);
  const firebaseUser = useAuthStore((state) => state.firebaseUser);
  const user = useAuthStore((state) => state.user);
  const firstTimeVisited = useAuthStore((state) => state.userStatus.firstTimeVisit);
  const [initialised, setInitialised] = useState(false);
  const dispatch = useAuthDispatch();
  const hasFirebaseUserData = firebaseUser !== undefined;

  useEffect(
    function initialiseAuthStack() {
      setInitialised(!user || hasFirebaseUserData);
    },
    [dispatch, firebaseUser, user]
  );

  useEffect(() => {
    if (
      process.env.REACT_APP_IGNORE_EMAIL_VERIFICATION === 'false' &&
      !firstTimeVisited &&
      !userIdMatch
    ) {
      if (firebaseUser?.emailVerified === false && user && !hasHcpReferralHash) {
        history.push('/auth/email-verification');
      } else if (!user && !hasHcpReferralHash) {
        history.replace({ pathname: '/auth/sign-in-or-register' });
      } else if (hasHcpReferralHash) {
        history.replace({ pathname: '/users/patient/consent' });
      } else if (initialised) {
        history.push('/');
      }
    } else if (hasHcpReferralHash && hasFirebaseUserData) {
      history.replace({ pathname: '/users/patient/consent' });
    }
  }, [firebaseUser, history, user, firstTimeVisited, hcpReferralHash, userIdMatch, initialised]);

  return initialised ? (
    <Switch data-testid="auth-stack">
      {Routes(AuthLayout, authLayoutRoutes, 0)}
      <Route path="*">
        <Redirect to={{ pathname: 'auth/sign-in-or-register' }} />
      </Route>
      <Route
        render={(props: RouteComponentProps) => (
          <AuthLayout>
            <NotFoundScreen {...props} />
          </AuthLayout>
        )}
      />
    </Switch>
  ) : (
    <Loader />
  );
};
